import { useReducer, useState, useCallback } from 'react'

type HeaderState = {
  showMenu: boolean
  showLoginModal: boolean
  showSignUpModal: boolean
  showAboutUsModal: boolean // Legacy support
  showPuppiesModal: boolean // Legacy support
  showVetsModal: boolean // Legacy support
}

type HeaderAction =
  | { type: 'TOGGLE_MENU'; value?: boolean }
  | {
      type: 'SET_MODAL'
      name: 'showLoginModal' | 'showSignUpModal'
      value: boolean
    }
  | { type: 'CLOSE_ALL' }
  // Legacy support for Menu.tsx and old components
  | { type: 'set'; name: keyof HeaderState; value: boolean }

const initialState: HeaderState = {
  showMenu: false,
  showLoginModal: false,
  showSignUpModal: false,
  showAboutUsModal: false,
  showPuppiesModal: false,
  showVetsModal: false,
}

function headerReducer(state: HeaderState, action: HeaderAction): HeaderState {
  switch (action.type) {
    case 'TOGGLE_MENU':
      return { ...state, showMenu: action.value ?? !state.showMenu }
    case 'SET_MODAL':
      return { ...state, [action.name]: action.value }
    case 'CLOSE_ALL':
      return initialState
    case 'set':
      return { ...state, [action.name]: action.value }
    default:
      return state
  }
}

export const useHeaderState = () => {
  const [state, dispatch] = useReducer(headerReducer, initialState)
  const [showPasswordModal, setShowPasswordModal] = useState(false)

  const toggleMenu = useCallback((value?: boolean) => {
    dispatch({ type: 'TOGGLE_MENU', value })
  }, [])

  const setLoginModal = useCallback((value: boolean) => {
    dispatch({ type: 'SET_MODAL', name: 'showLoginModal', value })
  }, [])

  const setSignUpModal = useCallback((value: boolean) => {
    dispatch({ type: 'SET_MODAL', name: 'showSignUpModal', value })
  }, [])

  const closeAll = useCallback(() => {
    dispatch({ type: 'CLOSE_ALL' })
  }, [])

  return {
    state,
    headerDispatch: dispatch,
    toggleMenu,
    setLoginModal,
    setSignUpModal,
    closeAll,
    showPasswordModal,
    setShowPasswordModal,
  }
}
